import React, { useContext } from "react";
import { AiFillInstagram } from "react-icons/ai";
import { FaGoogle, FaLocationDot, FaYoutube } from "react-icons/fa6";
import { IoMdCall } from "react-icons/io";
import { MdCancel, MdOutlineRestorePage } from "react-icons/md";
import { Link } from "react-router-dom";
import { data } from "../../App";

function Secondmenu() {
  const changer = useContext(data);
  return (
    <div
      style={{ transition: "0.4s" }}
      className={`fixed top-0 z-50 ${
        changer.menusecond ? "w-full" : "w-0"
      } h-full scroll-container overflow-y-scroll scrollbar-hidden`}
    >
      <div
        style={{ backgroundColor: "#fafafa" }}
        className="w-56 h-full border-r-2"
      >
        <div className="flex justify-center pt-5">
          <img className="w-44" src="../photo/logo.png" alt="" />
        </div>
        <div style={{ backgroundColor: "#fafafa" }} className="w-full">
          <div className="pt-5 px-3 w-full">
            <h5 style={{ color: "#3d7cc9" }} className="text-lg font-medium">
              Department
            </h5>
            <Link
              onClick={() => {
                changer.setMenufirst(false);
                changer.setMenusecond(false);
              }}
              to={"/bestdentalinwhitefield"}
              className=" flex  px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-gray-900 relative"
            >
              <MdOutlineRestorePage className="text-xl mr-1" />
              Dental care
            </Link>
            <Link
              onClick={() => {
                changer.setMenufirst(false);
                changer.setMenusecond(false);
              }}
              to={"/bestdermatologyservicesinwhitefield"}
              className=" flex  px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-gray-900 relative"
            >
              <MdOutlineRestorePage className="text-xl mr-1" />
              Dermatology
            </Link>
            <Link
              onClick={() => {
                changer.setMenufirst(false);
                changer.setMenusecond(false);
              }}
              to={"/bestcosmetictreatmentsinwhitefield"}
              className=" flex  px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-gray-900 relative"
            >
              <MdOutlineRestorePage className="text-xl mr-1" />
              Cosmetic Treatments
            </Link>
            <Link
              onClick={() => {
                changer.setMenufirst(false);
                changer.setMenusecond(false);
              }}
              to={"/bestinternalmedicineinwhitefield"}
              className="px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-gray-900 relative flex "
            >
              <MdOutlineRestorePage className="text-xl mr-1" />
              Internal Medicine
            </Link>
            <Link
              onClick={() => {
                changer.setMenufirst(false);
                changer.setMenusecond(false);
              }}
              to={"/bestdiabetesinwhitefield"}
              className=" flex  px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-gray-900 relative"
            >
              <MdOutlineRestorePage className="text-xl mr-1" />
              Diabetes
            </Link>
            <Link
              onClick={() => {
                changer.setMenufirst(false);
                changer.setMenusecond(false);
              }}
              to={"/bestorthopedicservicesinwhitefield"}
              className="flex  px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-gray-900 relative"
            >
              <MdOutlineRestorePage className="text-xl mr-1" />
              Orthopedic
            </Link>
            <Link
              onClick={() => {
                changer.setMenufirst(false);
                changer.setMenusecond(false);
              }}
              to={"/bestgeneralsurgeryinwhitefield"}
              className=" flex  px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-gray-900 relative"
            >
              <MdOutlineRestorePage className="text-xl mr-1" />
              General surgery
            </Link>
            <Link
              onClick={() => {
                changer.setMenufirst(false);
                changer.setMenusecond(false);
              }}
              to={"/bestpediatricsservicesinwhitefield"}
              className=" flex  px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-gray-900 relative"
            >
              <MdOutlineRestorePage className="text-xl mr-1" />
              Pediatrics
            </Link>
            <Link
              onClick={() => {
                changer.setMenufirst(false);
                changer.setMenusecond(false);
              }}
              to="/bestentinwhitefield"
              className=" flex  px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-gray-900 relative"
            >
              <MdOutlineRestorePage className="text-xl mr-1" />
              ENT
            </Link>
            <Link
              onClick={() => {
                changer.setMenufirst(false);
                changer.setMenusecond(false);
              }}
              to={"/bestphysiotherapyservicesinwhitefield"}
              className=" flex  px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-gray-900 relative"
            >
              <MdOutlineRestorePage className="text-xl mr-1" />
              Physiotherapy
            </Link>
            <Link
              onClick={() => {
                changer.setMenufirst(false);
                changer.setMenusecond(false);
              }}
              to={"/besturologyservicesinwhitefield"}
              className=" flex  px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-gray-900 relative"
            >
              <MdOutlineRestorePage className="text-xl mr-1" />
              Urology
            </Link>
            <Link
              onClick={() => {
                changer.setMenufirst(false);
                changer.setMenusecond(false);
              }}
              to={"/bestneurologyservicesinwhitefield"}
              className=" flex  px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-gray-900 relative"
            >
              <MdOutlineRestorePage className="text-xl mr-1" />
              Neurology
            </Link>
            <Link
              onClick={() => {
                changer.setMenufirst(false);
                changer.setMenusecond(false);
              }}
              to={"/bestpsychiatryservicesinwhitefield"}
              className=" flex  px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-gray-900 relative"
            >
              <MdOutlineRestorePage className="text-xl mr-1" />
              Psychiatry
            </Link>
            <Link
              onClick={() => {
                changer.setMenufirst(false);
                changer.setMenusecond(false);
              }}
              to={"/bestobgservicesinwhitefield"}
              className=" flex  px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-gray-900 relative"
            >
              <MdOutlineRestorePage className="text-xl mr-1" />
              Obstetrics and Gynecology
            </Link>
            <Link
              onClick={() => {
                changer.setMenufirst(false);
                changer.setMenusecond(false);
              }}
              to={"/bestcardiologyservicesinwhitefield"}
              className=" flex  px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-gray-900 relative"
            >
              <MdOutlineRestorePage className="text-xl mr-1" />
              Cardiology
            </Link>
          </div>
          <div
            style={{ backgroundColor: "#fafafa" }}
            className="py-3 px-3 w-full"
          >
            <h5 style={{ color: "#3d7cc9" }} className="text-lg font-medium">
              Contact Info
            </h5>
            <p>
              ELV Health Care Polyclinic, MR ASTER, Ground Floor Vijayanagar,
              Whitefield, Bengaluru, Karnataka 560066
            </p>
            <a
              href="tel:095352 64855"
              className=" flex pt-2 text-gray-700 hover:bg-gray-100 hover:text-gray-900 relative"
            >
              <IoMdCall className="text-xl mr-1" />
              095352 64855
            </a>
            <a
              href="tel:9535264855"
              className=" flex pt-2 text-gray-700 hover:bg-gray-100 hover:text-gray-900 relative"
            >
              <IoMdCall className="text-xl mr-1" />
              9535264855
            </a>
          </div>
          <div
            style={{ backgroundColor: "#fafafa" }}
            className="w-full flex justify-center pb-5"
          >
            <div className="flex">
              <FaYoutube className="text-2xl p-1" />
              <FaGoogle className="text-2xl p-1" />
              <FaLocationDot className="text-2xl p-1" />
              <AiFillInstagram className="text-2xl p-1" />
            </div>
          </div>
        </div>
      </div>
      <MdCancel
        onClick={() => {
          changer.setMenusecond(false);
        }}
        style={{ color: "#3d7cc9" }}
        className="text-3xl absolute z-40 top-2 right-2"
      />
    </div>
  );
}

export default Secondmenu;
